<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="pageVocabs + 'title'"
    [isForm]="true"
    [showBackBtn]="false"
    [showRefreshBtn]="false"
  >
  </app-page-header>

  <div class="app-page-content">
    <section>
      <fieldset>
        <legend>
          {{ pageVocabs + "webServiceSendHelp" | translate }}
        </legend>

        <div class="row">
          <div class="sm:tw-w-1/2 xl:tw-w-1/3">
            <fieldset class="border-navyBlue" style="height: 160px">
              <div class="row tw-text-center">
                <div>
                  {{ pageVocabs + "downloadDocumentations" | translate }}
                </div>
                <a
                  class="tw-mt-5 tw-text-center"
                  href="{{ guidanceDocumentations }}"
                  target="_blank"
                >
                  <span
                    [inlineSVG]="'/assets/media/svg/files/document.svg'"
                    title=""
                    class="svg-icon svg-icon-5x tw-flex-center"
                  ></span>
                </a>
              </div>
            </fieldset>
          </div>

          <div class="sm:tw-w-1/2 xl:tw-w-1/3">
            <!-- <p>{{configService.config$.value.gisApiUrl}} </p> -->
            <fieldset class="border-navyBlue" style="height: 160px">
              <div class="row tw-text-center">
                <div>{{ pageVocabs + "smartDocumentations" | translate }}</div>

                <a
                  class="tw-mt-5 tw-text-center"
                  href="{{ smartDocumentations }}"
                  target="_blank"
                >
                  <span
                    [inlineSVG]="'/assets/media/svg/files/document.svg'"
                    title=""
                    class="svg-icon svg-icon-5x tw-flex-center"
                  ></span>
                </a>
              </div>
            </fieldset>
          </div>
        </div>
      </fieldset>
    </section>
  </div>
</app-page-body>
